import React from "react";

import { Mail } from "lucide-react";

import Button from "../../../../Components/Button";
import CommonModal from "../../../../Components/Modal";

interface SendInvitationModalProps {
  isOpen: boolean;
  toggle: () => void;
  userName: string;
  userEmail: string;
  onConfirm: () => void;
  loading?: boolean;
}

const SendInvitationModal: React.FC<SendInvitationModalProps> = ({
  isOpen,
  toggle,
  userName,
  userEmail,
  onConfirm,
  loading = false,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title="Send Invitation"
      size="md"
    >
      <div>
        <p className="text-sm text-gray-600 mb-2 leading-relaxed">
          Send an invitation email to{" "}
          <strong className="text-gray-900 font-semibold">{userName}</strong>
        </p>
        <p className="text-sm text-gray-600 mb-4 leading-relaxed">
          The email will include a secure invitation link that allows the user
          to set their password and activate their account.
        </p>
        <div className="flex flex-col gap-1 mb-6 p-3 bg-gray-50 rounded-md">
          <span className="text-xs text-gray-500 font-medium">Email:</span>
          <span className="text-sm text-gray-900 font-normal">{userEmail}</span>
        </div>

        <div className="flex justify-end gap-3 pt-5 border-t border-gray-100">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant="primary"
            onClick={onConfirm}
            icon={<Mail size={16} />}
          >
            Send Invitation
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default SendInvitationModal;
